<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form ref="form" @submit.prevent="submitClick" autocomplete="off">
      <v-card>
        <v-card-text>
          <v-text-field
            outlined dense
            :rules="[required]"
            v-model="business_name"
            label="Business Name"
            validate-on-blur
          ></v-text-field>
          <v-text-field
            outlined dense
            :rules="[required]"
            v-model="contact_name"
            label="Contact"
            validate-on-blur
          ></v-text-field>
          <v-text-field
            outlined dense
            :rules="[required, valid_us_phone]"
            v-model="phone"
            label="Business Cell"
            autocomplete="pro_phone"
            v-mask="'(###) ###-####'"
            validate-on-blur
          ></v-text-field>
          <v-text-field
            outlined dense
            v-model="email"
            label="Email"
            autocomplete="pro_email"
          ></v-text-field>
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn class="ml-3" color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <ErrorOverlay
      title="Error Updating Pro"
      v-model="error_dialog"
      :loading="loading"
    >
      {{ error_message }}
    </ErrorOverlay>
  </v-dialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { ActivatorButton, ErrorOverlay } from '@/components/pages'
  import { required, valid_us_phone } from '@/lib/validations'

  export default {
    name: 'ContactDialog',

    components: { ActivatorButton, ErrorOverlay },

    data() {
      return {
        dialogVisible: false,

        business_name: '',
        contact_name: '',
        phone: '',
        email: '',


        // for error messages
        loading: false,
        error_dialog: false,
        error_message: '',

        // validation rules
        required, valid_us_phone,
      }
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.business_name = this.currentPro.business_name
          this.contact_name = this.currentPro.contact_name
          this.phone = this.currentPro.phone
          this.email = this.currentPro.email
        }
      },
    },

    computed: {
      ...mapGetters('pros', ['currentPro']),
    },

    methods: {
      ...mapActions('pros', ['updateCurrent']),

      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        if (this.$refs.form.validate()) {
          const payload = {
            business_name: this.business_name,
            contact_name: this.contact_name,
            phone: this.phone,
            email: this.email,
          }
          this.loading = true
          const result = await this.updateCurrent(payload)
          this.loading=false

          if(result.ok) {
            this.close()
          } else {
            this.error_dialog = true
            this.error_message = result.error
          }
        }
      }, 
    },
  }
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>